import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

interface CollectiveIconProps extends SvgIconProps {
    dotColor?: string;
}

function CollectiveIcon({ dotColor = 'black', ...props }: CollectiveIconProps) {
    return (
        <SvgIcon width="44" height="44" viewBox="0 0 44 44" fill="none" {...props}>
            <path
                d="M30.6029 27.5477C30.6029 28.2818 30.027 28.8691 29.307 28.8691C28.587 28.8691 28.011 28.2818 28.011 27.5477C28.011 26.8135 28.587 26.2262 29.307 26.2262C30.027 26.2262 30.6029 26.8135 30.6029 27.5477Z"
                fill={dotColor}
            />
            <path
                d="M27.147 29.6032C27.147 30.3373 26.571 30.9246 25.851 30.9246C25.131 30.9246 24.555 30.3373 24.555 29.6032C24.555 28.8691 25.131 28.2818 25.851 28.2818C26.571 28.2818 27.147 28.8691 27.147 29.6032Z"
                fill={dotColor}
            />
            <path
                d="M27.147 14.4068C27.147 15.1409 26.571 15.7282 25.851 15.7282C25.131 15.7282 24.555 15.1409 24.555 14.4068C24.555 13.6727 25.131 13.0854 25.851 13.0854C26.571 13.012 27.147 13.6727 27.147 14.4068Z"
                fill={dotColor}
            />
            <path
                d="M30.6029 16.389C30.6029 17.1231 30.027 17.7104 29.307 17.7104C28.587 17.7104 28.011 17.1231 28.011 16.389C28.011 15.6548 28.587 15.0675 29.307 15.0675C30.027 15.0675 30.6029 15.6548 30.6029 16.389Z"
                fill={dotColor}
            />
            <path
                d="M15.0511 19.9128C15.0511 20.6469 15.6271 21.2342 16.3471 21.2342C17.0671 21.2342 17.6431 20.6469 17.6431 19.9128C17.6431 19.1786 17.0671 18.5913 16.3471 18.5913C15.6271 18.5913 15.0511 19.1786 15.0511 19.9128Z"
                fill={dotColor}
            />
            <path
                d="M15.0511 24.0239C15.0511 24.758 15.6271 25.3453 16.3471 25.3453C17.0671 25.3453 17.6431 24.758 17.6431 24.0239C17.6431 23.2897 17.0671 22.7024 16.3471 22.7024C15.6271 22.7024 15.0511 23.2897 15.0511 24.0239Z"
                fill={dotColor}
            />
            <path
                d="M17.0671 27.5477C17.0671 28.2818 17.6431 28.8691 18.3631 28.8691C19.0831 28.8691 19.6591 28.2818 19.6591 27.5477C19.6591 26.8135 19.0831 26.2262 18.3631 26.2262C17.6431 26.2262 17.0671 26.8135 17.0671 27.5477Z"
                fill={dotColor}
            />
            <path
                d="M20.5231 29.6032C20.5231 30.3373 21.0991 30.9246 21.8191 30.9246C22.539 30.9246 23.115 30.3373 23.115 29.6032C23.115 28.8691 22.539 28.2818 21.8191 28.2818C21.0991 28.2818 20.5231 28.8691 20.5231 29.6032Z"
                fill={dotColor}
            />
            <path
                d="M20.5231 14.4068C20.5231 15.1409 21.0991 15.7282 21.8191 15.7282C22.539 15.7282 23.115 15.1409 23.115 14.4068C23.115 13.6727 22.539 13.0854 21.8191 13.0854C21.0991 13.012 20.5231 13.6727 20.5231 14.4068Z"
                fill={dotColor}
            />
            <path
                d="M17.0671 16.389C17.0671 17.1231 17.6431 17.7104 18.3631 17.7104C19.0831 17.7104 19.6591 17.1231 19.6591 16.389C19.6591 15.6548 19.0831 15.0675 18.3631 15.0675C17.6431 15.0675 17.0671 15.6548 17.0671 16.389Z"
                fill={dotColor}
            />
            <path
                d="M26.859 6.69851C26.715 7.2124 27.003 7.72628 27.507 7.87311C28.011 8.01993 28.515 7.72628 28.659 7.2124C28.803 6.69851 28.515 6.18462 28.011 6.0378C27.507 5.89097 27.003 6.18462 26.859 6.69851Z"
                fill={dotColor}
            />
            <path
                d="M28.587 36.5774C28.299 36.1369 27.723 35.9901 27.291 36.2103C26.859 36.504 26.715 37.0913 26.931 37.5318C27.219 37.9722 27.795 38.1191 28.227 37.8988C28.731 37.6052 28.875 37.0179 28.587 36.5774Z"
                fill={dotColor}
            />
            <path
                d="M17.1391 35.6964C17.2831 35.1825 16.9951 34.6687 16.4911 34.5218C15.9871 34.375 15.4831 34.6687 15.3391 35.1825C15.1951 35.6964 15.4831 36.2103 15.9871 36.3572C16.4911 36.504 16.9951 36.2103 17.1391 35.6964Z"
                fill={dotColor}
            />
            <path
                d="M9.72321 26.6667C10.0832 26.2996 10.0832 25.7123 9.72321 25.3453C9.36321 24.9782 8.78722 24.9782 8.42722 25.3453C8.06723 25.7123 8.06723 26.2996 8.42722 26.6667C8.78722 27.1072 9.36321 27.0338 9.72321 26.6667Z"
                fill={dotColor}
            />
            <path
                d="M15.3391 8.9743C15.6271 9.41477 16.2031 9.5616 16.6351 9.34136C17.0671 9.04771 17.2111 8.46041 16.9951 8.01993C16.7071 7.57946 16.1311 7.43263 15.6991 7.65287C15.2671 7.94652 15.1231 8.53382 15.3391 8.9743Z"
                fill={dotColor}
            />
            <path
                d="M27.075 10.3691C27.075 11.1033 26.499 11.6906 25.779 11.6906C25.059 11.6906 24.483 11.1033 24.483 10.3691C24.483 9.63501 25.059 9.04771 25.779 9.04771C26.571 9.04771 27.075 9.63501 27.075 10.3691Z"
                fill={dotColor}
            />
            <path
                d="M30.8909 11.764C30.8909 12.4981 30.3149 13.0854 29.595 13.0854C28.875 13.0854 28.299 12.4981 28.299 11.764C28.299 11.0298 28.875 10.4425 29.595 10.4425C30.3149 10.4425 30.8909 11.0298 30.8909 11.764Z"
                fill={dotColor}
            />
            <path
                d="M33.8429 14.4068C33.8429 15.0675 33.3389 15.5814 32.6909 15.5814C32.0429 15.5814 31.5389 15.0675 31.5389 14.4068C31.5389 13.7461 32.0429 13.2322 32.6909 13.2322C33.3389 13.2322 33.8429 13.7461 33.8429 14.4068Z"
                fill={dotColor}
            />
            <path
                d="M20.5231 10.3691C20.5231 11.1033 21.0991 11.6906 21.8191 11.6906C22.539 11.6906 23.115 11.1033 23.115 10.3691C23.115 9.63501 22.539 9.04771 21.8191 9.04771C21.0991 9.04771 20.5231 9.63501 20.5231 10.3691Z"
                fill={dotColor}
            />
            <path
                d="M16.7791 11.764C16.7791 12.4981 17.3551 13.0854 18.0751 13.0854C18.7951 13.0854 19.3711 12.4981 19.3711 11.764C19.3711 11.0298 18.7951 10.4425 18.0751 10.4425C17.3551 10.4425 16.7791 11.0298 16.7791 11.764Z"
                fill={dotColor}
            />
            <path
                d="M13.6832 14.4068C13.6832 15.1409 14.2591 15.7282 14.9791 15.7282C15.6991 15.7282 16.2751 15.1409 16.2751 14.4068C16.2751 13.6727 15.6991 13.0854 14.9791 13.0854C14.2591 13.0854 13.6832 13.6727 13.6832 14.4068Z"
                fill={dotColor}
            />
            <path
                d="M10.5872 17.4901C10.5872 18.0774 11.0912 18.5913 11.6672 18.5913C12.2432 18.5913 12.7472 18.0774 12.7472 17.4901C12.7472 16.9028 12.2432 16.389 11.6672 16.389C11.0912 16.389 10.5872 16.8294 10.5872 17.4901Z"
                fill={dotColor}
            />
            <path
                d="M20.5231 33.6409C20.5231 32.9068 21.0991 32.3195 21.8191 32.3195C22.539 32.3195 23.115 32.9068 23.115 33.6409C23.115 34.375 22.539 34.9623 21.8191 34.9623C21.0991 34.8889 20.5231 34.3016 20.5231 33.6409Z"
                fill={dotColor}
            />
            <path
                d="M16.7791 32.1726C16.7791 31.4385 17.3551 30.8512 18.0751 30.8512C18.7951 30.8512 19.3711 31.4385 19.3711 32.1726C19.3711 32.9068 18.7951 33.4941 18.0751 33.4941C17.3551 33.4941 16.7791 32.9068 16.7791 32.1726Z"
                fill={dotColor}
            />
            <path
                d="M13.6832 29.6032C13.6832 28.8691 14.2591 28.2818 14.9791 28.2818C15.6991 28.2818 16.2751 28.8691 16.2751 29.6032C16.2751 30.3373 15.6991 30.9246 14.9791 30.9246C14.2591 30.8512 13.6832 30.2639 13.6832 29.6032Z"
                fill={dotColor}
            />
            <path
                d="M11.6672 26.006C11.6672 25.2719 12.2432 24.6846 12.9632 24.6846C13.6832 24.6846 14.2591 25.2719 14.2591 26.006C14.2591 26.7401 13.6832 27.3274 12.9632 27.3274C12.2432 27.3274 11.6672 26.7401 11.6672 26.006Z"
                fill={dotColor}
            />
            <path
                d="M27.075 33.6409C27.075 32.9068 26.499 32.3195 25.779 32.3195C25.059 32.3195 24.483 32.9068 24.483 33.6409C24.483 34.375 25.059 34.9623 25.779 34.9623C26.571 34.8889 27.075 34.3016 27.075 33.6409Z"
                fill={dotColor}
            />
            <path
                d="M30.8909 32.1726C30.8909 31.4385 30.3149 30.8512 29.595 30.8512C28.875 30.8512 28.299 31.4385 28.299 32.1726C28.299 32.9068 28.875 33.4941 29.595 33.4941C30.3149 33.4941 30.8909 32.9068 30.8909 32.1726Z"
                fill={dotColor}
            />
            <path
                d="M33.8429 29.6032C33.8429 28.9425 33.3389 28.4286 32.6909 28.4286C32.0429 28.4286 31.5389 28.9425 31.5389 29.6032C31.5389 30.2639 32.0429 30.7778 32.6909 30.7778C33.3389 30.7044 33.8429 30.1905 33.8429 29.6032Z"
                fill={dotColor}
            />
            <path
                d="M11.0192 21.9683C11.0192 22.7024 11.5952 23.2897 12.3152 23.2897C13.0352 23.2897 13.6112 22.7024 13.6112 21.9683C13.6112 21.2342 13.0352 20.6469 12.3152 20.6469C11.5232 20.7203 11.0192 21.2342 11.0192 21.9683Z"
                fill={dotColor}
            />
        </SvgIcon>
    );
}

export default CollectiveIcon;
